var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamesbeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 181 102",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140,0c10.06.29,22.25.72,29.6,8.36,4.26,4.53,6.67,11.9,6.67,18.41,0,8.79-4,13.74-6.24,15.87-2.83,2.83-6.52,4.67-10.05,6.37,4.1,1.29,8.36,2.55,12.17,6.24,4.12,4.1,6.94,11.18,6.94,18.69a24.19,24.19,0,0,1-6.94,17.56c-7.92,8.07-18.41,8.22-29.74,8.5h-46V79.6l8.92.14V20.26l-8.92.14V0Zm-8.64,40.22c8.08.15,9.21.15,11.2-.27A9.65,9.65,0,0,0,150.23,30c0-5.24-3-8.21-5.09-9.21s-3.69-1.13-13.75-1.27Zm0,39.38h7.8c5.52,0,13.31-.13,13.31-9.62,0-5-2.69-8.36-6.1-9.64-2.4-1-3.53-1-15-1Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 42.92 0 42.92 20.4 34.13 20.26 48.72 77.48 64.45 20.26 55.67 20.4 55.67 0 95.04 0 95.04 20.4 88.38 20.26 63.6 100 31.3 100 6.23 20.26 0 20.4 0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesbeat);
export default __webpack_public_path__ + "static/media/gamesbeat.5f5ba9aabd7b08e75fde04427e35f375.svg";
export { ForwardRef as ReactComponent };